// extracted by mini-css-extract-plugin
export default {"servicesBox":"servicesbox_servicesBox__XjDdM","servicesBoxHovered":"servicesbox_servicesBoxHovered__tPap9","arrowHovered":"servicesbox_arrowHovered__P9cnS"};